<script lang="ts">
    import { navigate } from "svelte-routing/src/history"
    import { openExtendableNr, pages, rerender, scrollToRowNr } from "../../store"
    export let col: Column
    let focused = -1
</script>

<div class="link-container">
    {#each col.pageLinkBlocks as link, i}
        {#if isNaN(link.extendableRowNr)}
            <button
                class="page-ref"
                on:click="{() => {
                    $rerender = $rerender + 1
                    $scrollToRowNr = link.rowNr
                    navigate(Object.values($pages)?.find((o) => o.id == link.page)?.path || '/')
                }}"
            >
                {link.name}
            </button>
        {:else}
            <button
                on:mouseenter="{() => {
                    focused = i
                }}"
                on:mouseleave="{() => {
                    focused = -1
                }}"
                class="row-ref fill"
                on:click="{() => {
                    $rerender = $rerender + 1
                    $scrollToRowNr = link.rowNr
                    $openExtendableNr = link.extendableRowNr
                    navigate(Object.values($pages)?.find((o) => o.id == link.page)?.path || '/')
                }}"
            >
                <div>
                    {link.name}
                </div>
                <svg
                    data-src="/media/arrow-r.svg"
                    stroke="{i == focused ? '#fff' : 'black'}"
                    fill="{i == focused ? '#fff' : 'black'}"
                    style="z-index: 9999; position: relative;"></svg>
            </button>
        {/if}
    {/each}
</div>

<style lang="less">
    @import "../../assets/css/main.less";
    .link-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;

        button {
            background-color: @bg-color;
            color: @font-color;

            padding: 2px 15px;
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
            font-size: 0.7rem;
            @media @tablet {
                font-size: initial;
            }
        }

        .row-ref {
            display: flex;
            align-items: center;
            gap: 10px;
            border: 2px solid @bg-color-secondary;
            img {
                width: 20px;
                height: auto;
            }
        }

        .page-ref {
            background-color: @bg-color-secondary;
            color: @font-color-secondary;
            border: 2px solid @bg-color-secondary;
        }
    }
</style>
